export const Tag = {
  variants: {
    'editor-tag': {
      container: {
        bg: 'upgrade.blue.500',
        border: '2px solid',
        borderColor: '#7FB9F2',
        color: 'white',
        p: 1,
      },
    },
    'nonText-tag': {
      container: {
        bg: 'upgrade.blue.500',
        border: '2px solid',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        color: 'white',
        p: 1,
        _hover: {
          bg: 'upgrade.blue.700',
          cursor: 'pointer',
        },
      },
    },
    'missing-alt': {
      container: {
        bg: 'gray.700',
        border: '2px solid',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        color: 'white',
        p: 1,
        _hover: {
          bg: 'gray.900',
          cursor: 'pointer',
        },
      },
    },
    'suggested-tag': {
      container: {
        bg: 'white',
        color: 'white',
        border: '1px solid',
        borderRadius: 'base',
        borderColor: 'gray.200',
        minWidth: 'min-content',
        paddingX: 2,
        paddingY: 1,
        _hover: {
          bg: 'black-alpha.200',
          cursor: 'pointer',
        },
        _active: {
          bg: 'black-alpha.300',
        },
        transitionDuration: '200ms',
      },
      label: {
        color: 'font.500',
      },
    },
    'filter-tag': {
      container: {
        bg: 'upgrade.50',
        borderRadius: 'base',
        color: 'font.500',
      },
      label: {
        color: 'font.500',
      },
      closeButton: {
        opacity: 1,
      },
    },
  },
};
